import {
  type FC,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import type {
  ReferencesContextProps,
  ReferencesProviderProps,
  ReferencesState,
} from "./References.types";

const defaultReferences: ReferencesState = {
  customer: null,
  contract: null,
  site: null,
};

export const ReferencesContext = createContext<ReferencesContextProps>({
  references: { ...defaultReferences },
  setReferencesFunc: () => true,
});

export const ReferencesProvider: FC<ReferencesProviderProps> = ({
  children,
}) => {
  const [references, setReferences] =
    useState<ReferencesState>(defaultReferences);

  const setReferencesFunc = useCallback(
    (payload?: Partial<ReferencesState>) => {
      setReferences({
        ...defaultReferences,
        ...payload,
      });
    },
    [],
  );

  const contextReferencesValues = useMemo(
    () => ({ references, setReferencesFunc }),
    [references, setReferencesFunc],
  );

  return (
    <ReferencesContext.Provider value={contextReferencesValues}>
      {children}
    </ReferencesContext.Provider>
  );
};

export const useReferences = (): ReferencesContextProps => {
  const context = useContext(ReferencesContext);

  if (!context) {
    throw new Error("useReferences must be used within a ReferencesProvider");
  }

  return context;
};
